export default "__VITE_ASSET__uD6_TX8a__"